<template>
  <div>
    <jinkou />
  </div>
</template>

<script>
// 获取接口地址
import Jinkou from '../components/jkrk/jinkou.vue'

export default {
  name: 'Jkrk',
  components: {
    // sideMenu,
    // Header,
    Jinkou
  },
  data() {
    return {}
  },
  created: function() {},
  methods: {}
}
</script>

<style scoped>
</style>
